import { render, staticRenderFns } from "./OverViewCounts.vue?vue&type=template&id=0ef2cb0c&"
import script from "./OverViewCounts.vue?vue&type=script&lang=js&"
export * from "./OverViewCounts.vue?vue&type=script&lang=js&"
import style0 from "./OverViewCounts.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports